import React, { useEffect, useRef, useState } from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withRouter from 'react-router/withRouter';
import { get } from 'lodash';
import loadData from './nbtt_page_state_manager';
import { airtableMarkdownToHtml } from '../../../../utils/airtable';

import loadable from '@loadable/component';

const AdContainer = loadable(() =>
  import('../../../components/ad/AdContainer')
);
const FranchisePageLayout = loadable(
  () =>
    import('../../../fc-components/main/containers/FranchisePageLayout/FranchisePageLayout'),
  {
    resolveComponent: components => components.FranchisePageLayout
  }
);
const StickyBar = loadable(
  () => import('../../../components/StickyBar/StickyBar'),
  {
    resolveComponent: components => components.StickyBar
  }
);
const Section = loadable(
  () => import('../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Section
  }
);
const Supplemental = loadable(
  () => import('../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Supplemental
  }
);
const Spacer = loadable(
  () => import('../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Spacer
  }
);
const Text = loadable(() => import('../../../fc-components/main/components'), {
  resolveComponent: components => components.Text
});
const Blurb = loadable(() => import('../../../fc-components/main/components'), {
  resolveComponent: components => components.Blurb
});
const MultiTabList = loadable(
  () => import('../../../fc-components/main/components'),
  {
    resolveComponent: components => components.MultiTabList
  }
);

const nbttListPage = ({ franchisePage }) => {
  // Set all const variables
  const externalList = franchisePage?.data?.externalList || [];
  const winnersList = externalList?.winners || [];
  const categoriesList = externalList?.categories || [];
  const metadata = externalList?.metadata || {};

  const imageCaption = metadata?.['featureimage caption'];

  const seoHed = metadata?.Name || '';
  const seoSubHed = metadata?.Subhead || '';
  const franchiseBlurb = get(metadata, 'Blurb', '');
  const franchiseCredits = get(metadata, 'Contributors', '');

  const franchiseAnimatedFeatureImageDesktop =
    metadata?.['featureimage (desktop)'];

  const franchiseImageMobile = metadata?.['featureimage (mobile)'];
  const shareText = metadata?.shareText || '';

  // Set dynamic variables
  const [isMobile, setIsMobile] = useState(null);
  const [isTablet, setIsTablet] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [listFinal, setListFinal] = useState(null);

  const interstitialFreq = 10;
  const interstitialFreqAlt = 7;
  const interstitial = (
    <React.Fragment>
      <AdContainer type="break" />
    </React.Fragment>
  );

  // Supplemental Objects
  const topSupplemental = {
    alternate: false,
    title: metadata?.registerTitle || '',
    subtitle: metadata?.registerCopy || '',
    type: {
      content_type: 'button',
      button_text: metadata?.registerCTACopy || '',
      button_color: '#000',
      button_link: metadata?.registerLink || ''
    },
    colorTheme: 'transparent',
    image: false
  };

  const bottomSupplemental = {
    title: metadata?.pastYearsTitle || '',
    subtitle: metadata?.pastYearsCopy || '',
    alternate: true,
    type: {
      content_type: 'dropdown',
      dropdown_label: 'Choose Year',
      dropdown_links: [
        {
          dropdown_link:
            'https://www.fastcompany.com/next-big-things-in-tech/2022',
          dropdown_label: '2022'
        },
        {
          dropdown_link:
            'https://www.fastcompany.com/next-big-things-in-tech/2021',
          dropdown_label: '2021'
        }
      ]
    },
    colorTheme: 'transparent',
    image: false
  };

  // Helper functions

  const checkIfMobile = x => {
    setIsMobile(x.matches);
  };

  const checkIfTablet = (y, z) => {
    setIsTablet(y.matches && z.matches);
  };

  const createFormattedList = () => {
    const winnerObjFormatted = {
      behavior: 'link',
      category: 'Winners',
      data: [],
      fields: [
        { label: 'title', name: 'titles', weight: '1', width: '' },
        { label: 'company', name: 'company', weight: '0', width: '' }
      ],
      image: false,
      type: 'company_list'
    };

    winnersList.map(entry => {
      winnerObjFormatted.data.push({
        title: entry?.company || '',
        company: entry?.description || '',
        url: get(entry, 'url', '')
      });
      return '';
    });

    const categoriesObjFormatted = {
      behavior: 'link',
      category: 'Categories',
      data: [],
      fields: [
        { label: 'icon', name: 'icon', weight: '1', width: '50' },
        { label: 'title', name: 'titles', weight: '1', width: '' },
        { label: 'company', name: 'company', weight: '0', width: '' }
      ],
      image: false,
      type: 'company_list'
    };

    categoriesList.map(category => {
      categoriesObjFormatted.data.push({
        icon: category?.icon || '',
        title: category?.title || '',
        company: category?.description || '',
        url: get(category, 'url', '')
      });
      return '';
    });
    setListFinal([winnerObjFormatted, categoriesObjFormatted]);
  };

  const goToTopOfList = () => {
    const distance =
      window.pageYOffset +
      document.querySelector('.tabs__container').getBoundingClientRect().top;
    window.scrollTo({ top: distance - 70, left: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const x = window.matchMedia('(max-width: 640px)');
    const y = window.matchMedia('(min-width: 641px)');
    const z = window.matchMedia('(max-width: 1200px)');
    checkIfMobile(x);
    checkIfTablet(y, z);
    createFormattedList();
  }, []);

  useEffect(
    () => {
      if (isMobile) setActiveTab(0);
    },
    [isMobile]
  );

  const shareIcon = () => (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.36328 12.4871C2.80265 12.4873 2.26505 12.2647 1.8684 11.8684C1.47189 11.4723 1.24901 10.9348 1.24887 10.3743C1.24872 9.81371 1.47116 9.27606 1.86736 8.87961C2.26358 8.48317 2.80117 8.26019 3.36181 8.25993C3.92229 8.25964 4.46018 8.48204 4.85669 8.87818C5.25335 9.27433 5.47633 9.81168 5.47678 10.3722C5.47663 10.9328 5.25391 11.4703 4.85769 11.8669C4.46133 12.2634 3.92388 12.4864 3.36324 12.4871H3.36328ZM16.6141 14.8836C17.1748 14.8836 17.7124 15.1063 18.1087 15.5026C18.5052 15.8987 18.728 16.4362 18.7281 16.9968C18.7283 17.5572 18.5057 18.0948 18.1095 18.4912C17.7131 18.8877 17.1757 19.1105 16.615 19.1108C16.0545 19.1109 15.5168 18.8885 15.1201 18.4925C14.7236 18.0964 14.5006 17.559 14.5002 16.9985C14.5003 16.4378 14.7231 15.9002 15.1194 15.5036C15.5158 15.1072 16.0534 14.8841 16.6142 14.8836L16.6141 14.8836ZM16.6141 1.63643C17.1749 1.63643 17.7127 1.85926 18.1091 2.2557C18.5055 2.65215 18.7282 3.1898 18.7281 3.75045C18.7279 4.31114 18.5051 4.84879 18.1084 5.24509C17.7118 5.64138 17.174 5.86392 16.6133 5.86363C16.0525 5.86334 15.5149 5.64036 15.1185 5.2438C14.7223 4.84721 14.4999 4.30929 14.5002 3.74876C14.5009 3.18851 14.7238 2.65145 15.1201 2.25545C15.5165 1.85945 16.0538 1.63672 16.6141 1.63643ZM16.6141 7.10915C17.56 7.1093 18.4623 6.71112 19.0996 6.01225C19.7369 5.31337 20.0504 4.37843 19.963 3.4367C19.8757 2.49483 19.3957 1.63344 18.6409 1.06369C17.8859 0.49379 16.9259 0.268226 15.9961 0.442125C15.0663 0.616161 14.2527 1.17354 13.755 1.97778C13.2573 2.78201 13.1214 3.75871 13.3805 4.66833L6.03822 8.33831C5.46649 7.58689 4.60511 7.11044 3.66455 7.02565C2.72411 6.94072 1.79133 7.25525 1.09421 7.89209C0.397098 8.52905 0 9.42961 0 10.3738C0 11.3179 0.397061 12.2185 1.09421 12.8555C1.79133 13.4923 2.72414 13.8068 3.66455 13.7219C4.60514 13.6371 5.46653 13.1607 6.03822 12.4092L13.3805 16.0792C13.0685 17.1666 13.3221 18.3379 14.0559 19.199C14.7899 20.06 15.9064 20.496 17.0297 20.3604C18.153 20.2247 19.1335 19.5353 19.6412 18.5243C20.1488 17.5134 20.1161 16.3153 19.5539 15.3336C18.9918 14.3518 17.9751 13.7169 16.8461 13.6427C15.7172 13.5686 14.626 14.0649 13.9403 14.9646L6.59649 11.2921C6.7681 10.6919 6.7681 10.0557 6.59649 9.45556L13.9403 5.783C14.5752 6.61863 15.5644 7.10948 16.6141 7.10948L16.6141 7.10915Z"
        fill="black"
      />
    </svg>
  );

  return (
    <FranchisePageLayout modifier="nbtt_2023">
      <div className="nbtt__listPage">
        <img
          src="https://assets.fastcompany.com/image/upload/v1698809467/NBTIT_Header_animation_Desktop_1172x44.gif"
          alt=""
          className="header_animation"
        />
        <Section
          name="seo__meta"
          maxWidth={970}
          vMargins="20"
          bgColor="#f4f4f4"
        >
          <div className="seo__container">
            <div>
              <h1 className="seo__hed">{seoHed}</h1>
              <div
                className="seo__subhed"
                dangerouslySetInnerHTML={{ __html: seoSubHed }}
              />
            </div>
          </div>
        </Section>

        <Section name="advertorialBar" maxWidth={970} bgColor="#f4f4f4">
          <picture className="advertorial__feature">
            <source media="(max-width: 600px)" srcSet={franchiseImageMobile} />
            <img src={franchiseAnimatedFeatureImageDesktop} alt="" />
            <div className="imageCaption">
              <div
                dangerouslySetInnerHTML={{
                  __html: airtableMarkdownToHtml(imageCaption)
                }}
              />
              <img
                src="https://assets.fastcompany.com/image/upload/v1701192646/artistcredit_2.svg"
                alt=""
              />
            </div>
          </picture>
        </Section>
        <Section
          name="nbtt__blurb"
          maxWidth={700}
          vMargins="40"
          bgColor="#f4f4f4"
        >
          <Blurb
            text={airtableMarkdownToHtml(franchiseBlurb)}
            bug={metadata?.['Blurb image']}
            dropCap={false}
            buttonLabel="+ Read More"
            buttonLabelOpen="- Read Less"
            cutoff={404}
          />
        </Section>
        {listFinal && (
          <MultiTabList
            list="nbtt-2022"
            data={listFinal}
            interstitialUnit={interstitial}
            interstitialFreq={interstitialFreq}
            interstitialFreqAlt={interstitialFreqAlt}
            isMobile={isMobile}
            isTablet={isTablet}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        )}

        <Section
          maxWidth={970}
          bgColor="#f4f4f4"
          name="supplementalContainer"
          noPadding
        >
          <Supplemental {...topSupplemental} />
          <Spacer height="30px" />
          <Supplemental {...bottomSupplemental} />
        </Section>

        {franchiseCredits && (
          <Section
            maxWidth={970}
            bgColor="#f4f4f4"
            name="franchiseCredits"
            noPadding
          >
            <Text color="#000">
              <div
                dangerouslySetInnerHTML={{
                  __html: franchiseCredits
                }}
              />
            </Text>
          </Section>
        )}
      </div>

      <StickyBar
        slug="next-big-things-in-tech-2023"
        location="lander"
        post={{
          id: 'next-big-things-in-tech',
          slug: 'next-big-things-in-tech',
          title: 'Fast Company'
        }}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isMobile={isMobile}
        externalData={listFinal}
        svgWidth={20}
        svgHeight={20}
        overrideShareIcon={shareIcon()}
        overrideSocialText={encodeURIComponent(shareText)}
        scroll={goToTopOfList}
      />
    </FranchisePageLayout>
  );
};

nbttListPage.loadData = store => loadData(store);

function mapStateToProps(state = {}) {
  return {
    status: state.status.code,
    franchisePage: get(state, 'franchisePage') || {
      error: true
    },
    config: state.config
  };
}

nbttListPage.propTypes = {
  franchisePage: PropTypes.shape({
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(nbttListPage));
